import React from "react";
import Music from "source/app/services/Sound/Music/Music";

export function ShowPlaylistChangeText({
    currentPlaylistName,
    selectedPlaylistName,
}: {
    currentPlaylistName: string;
    selectedPlaylistName: string | undefined;
}) {
    if (!selectedPlaylistName || currentPlaylistName === selectedPlaylistName) {
        return null;
    }

    const isExtendedPlaylist =
        Music.ExtendedPlaylistMap.GetKeys().includes(selectedPlaylistName);

    if (isExtendedPlaylist) {
        return null;
    }

    return (
        <div style={{ marginBottom: `5px` }}>
            Playlist will change to <strong>{selectedPlaylistName}</strong> with
            next song
        </div>
    );
}
